// Neutral error reporting — no Lovable dependency.
// In production, this would forward to Sentry, Datadog, or OpenTelemetry.
type ErrorContext = Record<string, unknown>;

declare global {
  interface Window {
    __DIKDOC_ERROR_HANDLER__?: (error: Error, context: ErrorContext) => void;
  }
}

export function reportClientError(error: Error, context: ErrorContext = {}): void {
  if (typeof window === "undefined") return;
  // eslint-disable-next-line no-console
  console.error("[DIKDOC Error]", error, context);
  // Forward to global handler if registered (Sentry init, etc.)
  if (typeof window.__DIKDOC_ERROR_HANDLER__ === "function") {
    try {
      window.__DIKDOC_ERROR_HANDLER__(error, context);
    } catch {
      /* swallow */
    }
  }
}
